import React from 'react';

import { Link as RouterLink } from 'react-router-dom';

import {
  Link,
  Typography,
} from '@material-ui/core';

// Icons (see https://material-ui.com/components/material-icons/)
import {
  Email as EmailIcon,
} from '@material-ui/icons';

const ForgotPasswordSent = () => {
  return (
    <div>
      <EmailIcon color="action" style={{ fontSize: 140 }} />
      <Typography variant="h4" component="h1" color="textSecondary">
        Reset Link Sent
        </Typography>
      <Typography variant="body1" component="h1" color="textSecondary">
        If you provided us with an email address when you signed up, then you
        should receive an email in your inbox within the next 5 minutes.
        Please be sure to check your spam folder if you don’t see any
        email in your inbox.
      </Typography>

      <Link component={RouterLink} to="/sign-in" variant="body2">
        {"Return to login"}
      </Link>

    </div>
  );
}

export { ForgotPasswordSent };

